import { Button, Modal, Typography } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';

import {
  ModalActionButtons,
  ModalAlertInfo,
  ModalBox,
  ModalContent,
  ModalHeader,
} from './AlertModal.styles';

const AlertModal = ({
  open,
  onClose,
  title,
  content,
  additionalInfo,
  cancelButtonText,
  confirmButtonText,
  confirmButtonAction,
  confirmButtonDisabled = false,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  content: string;
  additionalInfo?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonAction: () => void;
  confirmButtonDisabled?: boolean;
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <ModalHeader>
          <Typography variant="h6" component="h2">
            {title ?? 'Atenção'}
          </Typography>
        </ModalHeader>

        <ModalContent>
          <Typography variant="body2" component="p">
            <span dangerouslySetInnerHTML={{ __html: content }} />
          </Typography>
        </ModalContent>

        <ModalAlertInfo>
          <Typography variant="body2" component="p" fontWeight="bold">
            {additionalInfo}
          </Typography>
        </ModalAlertInfo>

        <ModalActionButtons
          container
          spacing={2}
          justifyContent="flex-end"
          mt={2}
        >
          <Grid>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => onClose()}
            >
              {cancelButtonText ?? 'Cancelar'}
            </Button>
          </Grid>
          <Grid>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => confirmButtonAction()}
              disabled={confirmButtonDisabled}
            >
              {confirmButtonText ?? 'Confirmar'}
            </Button>
          </Grid>
        </ModalActionButtons>
      </ModalBox>
    </Modal>
  );
};

export default AlertModal;
